import React, { useRef } from 'react'
import { Chart as ChartJS } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { getNumberAsThousandsStr } from '../utils'
import { ANIMATION_DURATION } from './constants'
import './registerCharts'

export interface Props {
	data: any
	options?: any
	/**
	 * Fill the parent's height as well as its width, and size the text for a
	 * slide (MYD-499). Off, the chart keeps Chart.js's aspect ratio, as on the
	 * Demographics tab.
	 */
	fill?: boolean
	/** The value labels' size in px. */
	fontSize?: number
}

const PieChart = ({ data, options, fill = false, fontSize = 12 }: Props) => {
	const chartRef = useRef<ChartJS>(null)

	const defaultBarChartOptions = {
		responsive: true,
		...(fill ? { maintainAspectRatio: false } : {}),
		animation: {
			duration: ANIMATION_DURATION,
			easing: 'easeOutQuart',
			onComplete: function () {
				const chart = chartRef.current
				const ctx = chart?.ctx

				if (ctx) {
					ctx.font = `bold ${fontSize}px Inter, sans-serif`
					ctx.fillStyle = '#000'
					ctx.textAlign = 'center'
					ctx.textBaseline = 'bottom'

					chart.data.datasets.forEach((dataset, index) => {
						for (let i = 0; i < dataset.data.length; i++) {
							const meta = chart.getDatasetMeta(index) as any
							const model = meta.data[i]

							// An area with no figure has no bar, and must not be labelled
							// "NaNk" (a location with no CBSA, MYD-499).
							if (typeof dataset.data[i] !== 'number' || !Number.isFinite(dataset.data[i])) continue
							ctx.fillText(getNumberAsThousandsStr(dataset.data[i]), model.x, model.y - 0)
						}
					})
				}
			},
		},
		hover: { mode: null },
		plugins: {
			legend: {
				display: !!options?.showLegend,
				...(fill ? { labels: { font: { size: fontSize } } } : {}),
			},
			tooltip: {
				enabled: false,
			},
		},
		scales: {
			yAxes: {
				ticks: {
					...(fill ? { font: { size: fontSize } } : {}),
					callback: function (label, index, labels) {
						return label === 0 ? '0' : `${getNumberAsThousandsStr(label)}`
					},
				},
			},
			...(fill ? { x: { ticks: { font: { size: fontSize } } } } : {}),
		},
	}

	const barChartOptions = {
		...defaultBarChartOptions,
	}

	// @ts-ignore
	return <Bar ref={chartRef} options={barChartOptions} data={data} />
}

export default PieChart
